import { isValidPhoneNumber } from "libphonenumber-js";

export function isPhoneValid(input: string): boolean {
  const trimmed = input.trim();
  if (!trimmed) return false;
  try {
    return isValidPhoneNumber(trimmed, "RS");
  } catch {
    return false;
  }
}
